import axios from 'axios'
import { ElMessage } from 'element-plus'
import { tansParams, blobValidate } from "@/utils/ruoyi";

let downloadLoadingInstance;

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: "/",
    // 超时
    timeout: 60000
})

// request拦截器
service.interceptors.request.use(config => {

    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
        const requestObj = {
            url: config.url,
            data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
            time: new Date().getTime()
        }
        const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
        // const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
        // if (requestSize >= limitSize) {
        //   console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
        //   return config;
        // }
            // const s_url = sessionObj.url;                  // 请求地址
            // const s_data = sessionObj.data;                // 请求数据
            // const s_time = sessionObj.time;                // 请求时间
            // const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
            // if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
            //     const message = '数据正在处理，请勿重复提交';
            //     console.warn(`[${s_url}]: ` + message)
            //     return Promise.reject(new Error(message))
            // }

    }
    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 二进制数据则直接返回
        if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
            return res.data
        }
            return res.data

    },
    error => {
        let { message } = error;
        if (message == "Network Error") {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        ElMessage({ message: message, type: 'error', duration: 5 * 1000 })
        return Promise.reject(error)
    }
)

export default service
